import type { PropsWithChildren } from "react";
import React, { createContext, useContext } from "react";

import type { PrismaVersionType, ThemeVersionProviderProps } from "./types";

const ThemeVersionContext = createContext<PrismaVersionType>("cobalt");

export const ThemeVersionProvider = ({
  children,
  version,
}: PropsWithChildren<ThemeVersionProviderProps>) => {
  return (
    <ThemeVersionContext.Provider value={version}>
      {children}
    </ThemeVersionContext.Provider>
  );
};

export const useThemeVersion = () => {
  return useContext(ThemeVersionContext);
};
